<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('projectDetail',row.id)">详情</span>
                </template> -->
      </Table>
      <!-- <Page
        class="page"
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page> -->
    </div>
  </div>
</template>
<script>
import tableMixin from "@/components/tableMixin";
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  mixins: [tableMixin, tableTwoMixin],
  data() {
    return {
      // loading: false,
      // tableData: [],
      // dataType: "",
      // optId: "",
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "总承包单位统一社会信用代码",
          key: "contractorCorpCode",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "总承包单位名称",
          key: "contractorCorpName",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "项目名称",
          key: "name",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "项目简介",
          key: "description",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "项目分类",
          key: "category",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "建设单位名称",
          key: "buildCorpName",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "建设单位统一社会信用代码",
          key: "buildCorpCode",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "建设用地规划许可证编号",
          key: "buildPlanNum",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        {
          title: "建设工程规划许可证编号",
          key: "prjPlanNum",
          align: "center",
          minWidth: 210,
          tooltip: true,
        },
        {
          title: "项目所在地",
          key: "areaCode",
          minWidth: 120,
          align: "center",
          tooltip: true,
        },
        {
          title: "总投资(万元)",
          key: "invest",
          align: "center",
          minWidth: 100,
        },

        {
          title: "总面积(平方米)",
          key: "buildingArea",
          align: "center",
          minWidth: 100,
        },
        {
          title: "总长度(米)",
          key: "buildingLength",
          align: "center",
          minWidth: 100,
        },
        {
          title: "开工日期",
          key: "startDate",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "竣工日期",
          key: "completeDate",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "联系人姓名",
          key: "linkMan",
          align: "center",
          minWidth: 180,
        },
        {
          title: "联系人办公电话",
          key: "linkPhone",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "项目状态",
          key: "prjStatus",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "WGS84经度",
          key: "lat",
          align: "center",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "WGS84纬度",
          key: "lng",
          align: "center",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "项目地点",
          key: "address",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "立项文号",
          key: "approvalNum",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "立项级别",
          key: "approvalLevelNum",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "建设规模",
          key: "prjSize",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "建设性质",
          key: "propertyNum",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "工程用途",
          key: "functionNum",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "国籍或地区",
          key: "nationNum",
          align: "center",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "数据来源",
          key: "areaCode",
          align: "center",
          minWidth: 100,
        },
      ],
    };
  },
  created() {},
};
</script>
